var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasCategories)?_c('CategorizedFaqList',{attrs:{"categories":_vm.categories}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }